import { Component, EventEmitter, Output } from '@angular/core';
import { DocumentChecklistListContent } from '@src/app/public/document-checklist/inheritance/content/checklist-content';
import { ButtonModule } from '@vg-constellation/angular-16/button';

@Component({
  selector: 'app-complete-your-transfer-banner',
  templateUrl: './complete-your-transfer-banner.component.html',
  styleUrls: ['./complete-your-transfer-banner.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class CompleteYourTransferBannerComponent {
  content = DocumentChecklistListContent.completeYourTransferBanner;

  @Output() getStarted = new EventEmitter<void>();

  onGetStarted(): void {
    this.getStarted.emit();
  }
}
